module.exports = __webpack_public_path__ + "static/media/welcome-2.34ce1d4a.jpg";